import { Component, OnInit, Input } from '@angular/core';
import { WS } from 'src/app/core/services/ws.service';

@Component({
  selector: 'app-quiz-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.scss']
})
export class LinksComponent implements OnInit {
  
  @Input() question: any;
  constructor(public ws: WS) { }
  

  ngOnInit(): void {
  }


  save(): void {
    this.ws.put('questions/' + this.question.id, this.question)
      .subscribe(data => {
        // this.toastr.success('Mise à jour avec succès');
        // console.log(data);
      });
  }
  getQuestionType(type): string{
    return {
      'title':'Titre',
      'radio':'QCM / QCU',
      'slider':'Intervalle',
      'textarea':'Ouverte',
      'photos':'Fichiers',
      'links':'Liens',
      'rank':'Évaluation'
    }[type];
  }
}
